export default {
  primary: '#8bc34a',
  secondary: '#895cd8',
  dark: '#2C3E50',
  light: '#f7f7f7',
  text: 'rgba(0, 0, 0, 0.870588)',
  pallet: ['#fff', '#f1f1f1', '#eaeaea', '#ccc', '#aaa', '#888', '#666', '#444', '#222', '#000', '#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#95d847', '#8ED1FC', '#0693E3', '#EB144C', '#F78DA7'],
}


// WEBPACK FOOTER //
// ./src/styles/theme.js